import { gql } from '@apollo/client';

export const GET_SITES = gql`
  query {
    findAllBySystem(system: "Dash") {
      id
      domain
      initial
      name
      system
    }
  }
`;

export const UPLOAD_IMAGE_SITE = `
  mutation uploadImageContent($file: String!, $siteDomain: String!) {
    uploadImageContent(file: $file, siteDomain : $siteDomain) {
      url
    }
  }
`;

export const SITES = gql`
  query sites($hosted: EHosted!) {
    sites(hosted: $hosted) {
      id
      domain
      languages
    }
  }
`;

export const SITE_BY_DOMAIN = gql`
  query($domain: String!) {
    siteByDomain(domain: $domain) {
      languages
    }
  }
`;

export const UPDATE_CONTENT_RELATED_SITE_SETTINGS = gql`
  mutation($id: String!, $languages: [String!]) {
    updateContentRelatedSiteSettings(
      id: $id
      input: { languages: $languages }
    ) {
      languages
    }
  }
`;

export const CHECK_SITE_HEALTH = gql`
  query checkSiteHealth($domain: String!) {
    checkSiteHealth(domain: $domain) {
      isSiteOnline
    }
  }
`;
